export class CompanyContactDetails {
    companyName: any = null;
    firstname: any = null;
    lastname: any = null;
    phonenumber: any = null;
    email: any = null;
}